export default __webpack_public_path__ + "static/media/bg.ad7cbc86.jpg";